import { useState } from 'react'
import { Sparkles } from 'lucide-react'
import { Button } from '@shared/components/ui/button'
import { Tooltip, TooltipContent, TooltipTrigger } from '@shared/components/ui/tooltip'
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
} from '@shared/components/ui/sheet'

export function TopBarAssistant() {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button variant="ghost" size="icon" className="h-8 w-8" onClick={() => setOpen(true)}>
            <Sparkles className="h-4 w-4" />
          </Button>
        </TooltipTrigger>
        <TooltipContent>Assistant</TooltipContent>
      </Tooltip>

      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="right" size="sm">
          <SheetHeader>
            <SheetTitle>AI Assistant</SheetTitle>
            <SheetDescription>
              Your intelligent assistant for navigating and managing the platform.
            </SheetDescription>
          </SheetHeader>
          <div className="flex flex-col items-center justify-center flex-1 py-16 text-center">
            <div className="h-12 w-12 rounded-full bg-muted flex items-center justify-center mb-4">
              <Sparkles className="h-6 w-6 text-muted-foreground" />
            </div>
            <p className="text-sm font-medium">Coming soon</p>
            <p className="text-xs text-muted-foreground mt-1 max-w-[240px]">
              AI-powered assistance for payments, billing, and platform management.
            </p>
          </div>
        </SheetContent>
      </Sheet>
    </>
  )
}
